import axios from "axios";
axios.interceptors.request.use(
  (config) => {
    config.data = JSON.stringify(config.data);
    config.headers["content-type"] = "application/json;charset=utf-8";
    return config;
  },
  (err) => {
    Promise.reject(err);
  }
);
axios.interceptors.response.use(
  (response) => {
    return response;
  },
  (err) => {
    Promise.reject(err);
  }
);
export default axios;
